<div  #modal>
    <video #video
           autoplay="true"
           muted="muted"
           controls [src]="'assets/impacto.mp4'"></video>
</div>
